var _style, _defs, _g, _g2, _g3, _g4, _defs2, _g5, _defs3, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _g8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 250",
    style: {
      enableBackground: "new 0 0 700 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{opacity:0.5;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:2.1221;stroke-miterlimit:10;}\n\t.st5{opacity:0.8;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:0.6667;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.8333;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:1.1667;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:1.3333;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:1.6667;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.8333;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:2.1667;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:2.3333;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#FFFFFF;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#FFFFFF;stroke-width:2.6667;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#FFFFFF;stroke-width:2.8333;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st22{opacity:0.79;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#FFFFFF;stroke-width:1.25;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#FFFFFF;stroke-width:1.75;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#FFFFFF;stroke-width:2.25;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#FFFFFF;stroke-width:2.75;stroke-miterlimit:10;}\n\t.st28{opacity:0.89;}\n\t.st29{fill:none;stroke:#FFFFFF;stroke-width:0.8127;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.3504;}\n\t.st30{fill:none;stroke:#FFFFFF;stroke-width:0.9493;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.227;}\n\t.st31{fill:none;stroke:#FFFFFF;stroke-width:1.0859;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.0907;}\n\t.st32{fill:none;stroke:#FFFFFF;stroke-width:1.2225;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.9825;}\n\t.st33{fill:none;stroke:#FFFFFF;stroke-width:1.359;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.8595;}\n\t.st34{fill:none;stroke:#FFFFFF;stroke-width:1.4956;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.7651;}\n\t.st35{fill:none;stroke:#FFFFFF;stroke-width:1.6322;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.6526;}\n\t.st36{fill:none;stroke:#FFFFFF;stroke-width:1.7688;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.5163;}\n\t.st37{fill:none;stroke:#FFFFFF;stroke-width:1.9054;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.4053;}\n\t.st38{fill:none;stroke:#FFFFFF;stroke-width:2.042;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.3253;}\n\t.st39{fill:none;stroke:#FFFFFF;stroke-width:2.1786;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.2093;}\n\t.st40{fill:none;stroke:#FFFFFF;stroke-width:2.3152;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.1269;}\n\t.st41{opacity:0.81;}\n\t.st42{fill:none;stroke:#FFFFFF;stroke-width:1.0531;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.6328;}\n\t.st43{fill:none;stroke:#FFFFFF;stroke-width:1.1504;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.5491;}\n\t.st44{fill:none;stroke:#FFFFFF;stroke-width:1.2478;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.461;}\n\t.st45{fill:none;stroke:#FFFFFF;stroke-width:1.3451;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.368;}\n\t.st46{fill:none;stroke:#FFFFFF;stroke-width:1.4425;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.3075;}\n\t.st47{fill:none;stroke:#FFFFFF;stroke-width:1.5398;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.2037;}\n\t.st48{fill:none;stroke:#FFFFFF;stroke-width:1.6371;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.1328;}\n\t.st49{fill:none;stroke:#FFFFFF;stroke-width:1.7345;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,5.0562;}\n\t.st50{fill:none;stroke:#FFFFFF;stroke-width:1.8318;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.9732;}\n\t.st51{fill:none;stroke:#FFFFFF;stroke-width:1.9292;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.8829;}\n\t.st52{fill:none;stroke:#FFFFFF;stroke-width:2.0265;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.8284;}\n\t.st53{fill:none;stroke:#FFFFFF;stroke-width:2.1239;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.7217;}\n\t.st54{fill:none;stroke:#FFFFFF;stroke-width:2.2212;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.6512;}\n\t.st55{fill:none;stroke:#FFFFFF;stroke-width:2.3186;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.5711;}\n\t.st56{fill:none;stroke:#FFFFFF;stroke-width:2.4159;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.4798;}\n\t.st57{fill:none;stroke:#FFFFFF;stroke-width:2.5133;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.4302;}\n\t.st58{fill:none;stroke:#FFFFFF;stroke-width:2.6106;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.3117;}\n\t.st59{fill:none;stroke:#FFFFFF;stroke-width:2.708;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.2352;}\n\t.st60{fill:none;stroke:#FFFFFF;stroke-width:2.8053;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.1405;}\n\t.st61{fill:none;stroke:#FFFFFF;stroke-width:2.9027;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.0992;}\n\t.st62{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4.0426;}\n\t.st63{opacity:0.77;}\n\t.st64{clip-path:url(#SVGID_4_);}\n\t.st65{clip-path:url(#SVGID_6_);}\n\t.st66{opacity:0.72;}\n\t.st67{opacity:0.5;fill:none;stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n\t.st68{opacity:0.5;fill:none;stroke:#FFFFFF;stroke-width:30;stroke-miterlimit:10;}\n\t.st69{opacity:0.5;fill:url(#SVGID_7_);}\n\t.st70{opacity:0.5;fill:url(#SVGID_8_);}\n\t.st71{opacity:0.5;fill:url(#SVGID_9_);}\n\t.st72{opacity:0.5;fill:url(#SVGID_10_);}\n\t.st73{opacity:0.5;fill:url(#SVGID_11_);}\n\t.st74{opacity:0.5;fill:url(#SVGID_12_);}\n\t.st75{opacity:0.5;fill:url(#SVGID_13_);}\n\t.st76{opacity:0.49;}\n\t.st77{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -216.4,
    className: "st0",
    width: 699.6,
    height: 466.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 593.8,
    cy: 153.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 579.6,
    cy: 153.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 565.3,
    cy: 153.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 551,
    cy: 153.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 536.7,
    cy: 153.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 53.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 67.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 82.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 96.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 110.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 124.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 139.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 522.5,
    cy: 153.5,
    r: 1.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 405.8,
    y1: 250,
    x2: 345.7,
    y2: 310.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 401.5,
    y1: 245.6,
    x2: 341.3,
    y2: 305.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 397.1,
    y1: 241.3,
    x2: 337,
    y2: 301.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 392.8,
    y1: 236.9,
    x2: 332.7,
    y2: 297.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 388.5,
    y1: 232.6,
    x2: 328.3,
    y2: 292.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 384.1,
    y1: 228.3,
    x2: 324,
    y2: 288.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 379.8,
    y1: 223.9,
    x2: 319.6,
    y2: 284.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 375.4,
    y1: 219.6,
    x2: 315.3,
    y2: 279.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 371.1,
    y1: 215.2,
    x2: 310.9,
    y2: 275.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 366.7,
    y1: 210.9,
    x2: 306.6,
    y2: 271
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 362.4,
    y1: 206.5,
    x2: 302.3,
    y2: 266.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.1,
    y1: 202.2,
    x2: 297.9,
    y2: 262.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 353.7,
    y1: 197.9,
    x2: 293.6,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 349.4,
    y1: 193.5,
    x2: 289.2,
    y2: 253.7
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 419.4,
    cy: 4,
    r: 86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 419.4,
    cy: 4,
    r: 79.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 419.4,
    cy: 4,
    r: 72.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 419.4,
    cy: 4,
    r: 66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 419.4,
    cy: 4,
    r: 59.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 419.4,
    cy: 4,
    r: 52.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 419.4,
    cy: 4,
    r: 46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 419.4,
    cy: 4,
    r: 39.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 419.4,
    cy: 4,
    r: 32.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 419.4,
    cy: 4,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 419.4,
    cy: 4,
    r: 19.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st29",
    cx: 168.3,
    cy: -34.1,
    r: 75.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 168.3,
    cy: -34.1,
    r: 70
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 168.3,
    cy: -34.1,
    r: 64.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 168.3,
    cy: -34.1,
    r: 59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 168.3,
    cy: -34.1,
    r: 53.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 168.3,
    cy: -34.1,
    r: 48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 168.3,
    cy: -34.1,
    r: 42.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st36",
    cx: 168.3,
    cy: -34.1,
    r: 36.9
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    className: "st63",
    cx: 298.8,
    cy: 77.6,
    r: 30.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st64"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 255.4,
    y1: 12.6,
    x2: 125.3,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 263.5,
    y1: 12.6,
    x2: 133.3,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 271.5,
    y1: 12.6,
    x2: 141.4,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 279.5,
    y1: 12.6,
    x2: 149.4,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 287.6,
    y1: 12.6,
    x2: 157.4,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 295.6,
    y1: 12.6,
    x2: 165.5,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303.6,
    y1: 12.6,
    x2: 173.5,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 311.7,
    y1: 12.6,
    x2: 181.5,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 319.7,
    y1: 12.6,
    x2: 189.6,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 327.7,
    y1: 12.6,
    x2: 197.6,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 335.8,
    y1: 12.6,
    x2: 205.6,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 343.8,
    y1: 12.6,
    x2: 213.7,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 351.8,
    y1: 12.6,
    x2: 221.7,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 359.9,
    y1: 12.6,
    x2: 229.7,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 367.9,
    y1: 12.6,
    x2: 237.8,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 375.9,
    y1: 12.6,
    x2: 245.8,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 384,
    y1: 12.6,
    x2: 253.8,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 392,
    y1: 12.6,
    x2: 261.9,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 400,
    y1: 12.6,
    x2: 269.9,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 408.1,
    y1: 12.6,
    x2: 277.9,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 416.1,
    y1: 12.6,
    x2: 286,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 424.1,
    y1: 12.6,
    x2: 294,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 432.2,
    y1: 12.6,
    x2: 302,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 440.2,
    y1: 12.6,
    x2: 310,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 448.2,
    y1: 12.6,
    x2: 318.1,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 456.2,
    y1: 12.6,
    x2: 326.1,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 464.3,
    y1: 12.6,
    x2: 334.1,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 472.3,
    y1: 12.6,
    x2: 342.2,
    y2: 142.7
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_5_",
    className: "st41",
    cx: 630.1,
    cy: 259.3,
    r: 96.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st65"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 614.5,
    y1: 103.6,
    x2: 305.7,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 622.5,
    y1: 103.6,
    x2: 313.6,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 630.4,
    y1: 103.6,
    x2: 321.5,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 638.3,
    y1: 103.6,
    x2: 329.5,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 646.3,
    y1: 103.6,
    x2: 337.4,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 654.2,
    y1: 103.6,
    x2: 345.3,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 662.1,
    y1: 103.6,
    x2: 353.3,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 670,
    y1: 103.6,
    x2: 361.2,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 678,
    y1: 103.6,
    x2: 369.1,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 685.9,
    y1: 103.6,
    x2: 377.1,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 693.8,
    y1: 103.6,
    x2: 385,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 701.8,
    y1: 103.6,
    x2: 392.9,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 709.7,
    y1: 103.6,
    x2: 400.9,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 717.6,
    y1: 103.6,
    x2: 408.8,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 725.6,
    y1: 103.6,
    x2: 416.7,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 733.5,
    y1: 103.6,
    x2: 424.7,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 741.4,
    y1: 103.6,
    x2: 432.6,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 749.4,
    y1: 103.6,
    x2: 440.5,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 757.3,
    y1: 103.6,
    x2: 448.5,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 765.2,
    y1: 103.6,
    x2: 456.4,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 773.2,
    y1: 103.6,
    x2: 464.3,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 781.1,
    y1: 103.6,
    x2: 472.3,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 789,
    y1: 103.6,
    x2: 480.2,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 797,
    y1: 103.6,
    x2: 488.1,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 804.9,
    y1: 103.6,
    x2: 496.1,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 812.8,
    y1: 103.6,
    x2: 504,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 820.8,
    y1: 103.6,
    x2: 511.9,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 828.7,
    y1: 103.6,
    x2: 519.9,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 836.6,
    y1: 103.6,
    x2: 527.8,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 844.6,
    y1: 103.6,
    x2: 535.7,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 852.5,
    y1: 103.6,
    x2: 543.7,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 860.4,
    y1: 103.6,
    x2: 551.6,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 868.4,
    y1: 103.6,
    x2: 559.5,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 876.3,
    y1: 103.6,
    x2: 567.4,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 884.2,
    y1: 103.6,
    x2: 575.4,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 892.2,
    y1: 103.6,
    x2: 583.3,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 900.1,
    y1: 103.6,
    x2: 591.2,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 908,
    y1: 103.6,
    x2: 599.2,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 916,
    y1: 103.6,
    x2: 607.1,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 923.9,
    y1: 103.6,
    x2: 615,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 931.8,
    y1: 103.6,
    x2: 623,
    y2: 412.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 939.8,
    y1: 103.6,
    x2: 630.9,
    y2: 412.4
  }))))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -118.5,
    y: -13.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -68.0136 15.8072)",
    className: "st67",
    width: 207.1,
    height: 207.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: -160,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 244.8285 478.1967)",
    className: "st67",
    width: 207.1,
    height: 207.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.3,
    y: 187.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -103.5449 332.6936)",
    className: "st68",
    width: 207.1,
    height: 207.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 2020.1781,
    y1: -659.5848,
    x2: 2020.1781,
    y2: -946.6803,
    gradientTransform: "matrix(-0.4778 -0.4778 0.7154 -0.7154 1511.4592 596.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M74.4,103.4L74.4,103.4c13.9,13.9,13.9,36.5,0,50.4l-155,155c-13.9,13.9-36.5,13.9-50.4,0h0 c-13.9-13.9-13.9-36.5,0-50.4l155-155C37.9,89.5,60.4,89.5,74.4,103.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1474.8177,
    y1: -521.5536,
    x2: 1474.8177,
    y2: -732.3757,
    gradientTransform: "matrix(-0.7071 -0.7071 1.0176 -1.0176 1810.4424 601.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M236.9,89.2L236.9,89.2c15.1,15.1,15.1,39.6,0,54.7L77.1,303.7c-15.1,15.1-39.6,15.1-54.7,0v0 c-15.1-15.1-15.1-39.6,0-54.7L182.1,89.2C197.2,74.1,221.7,74.1,236.9,89.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1404.5374,
    y1: -617.3339,
    x2: 1404.5374,
    y2: -756.6317,
    gradientTransform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 1660.7268 751.0263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M231.1,194.4L231.1,194.4c7.2,7.2,7.2,18.9,0,26.1l-72.4,72.4c-7.2,7.2-18.9,7.2-26.1,0h0 c-7.2-7.2-7.2-18.9,0-26.1l72.4-72.4C212.2,187.2,223.9,187.2,231.1,194.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5493,
    y1: 143.7638,
    x2: 103.1173,
    y2: 224.1959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M171.7,155.6L171.7,155.6c9.6,9.6,9.6,25.2,0,34.9L27.8,334.4c-9.6,9.6-25.2,9.6-34.9,0l0,0 c-9.6-9.6-9.6-25.2,0-34.9l143.9-143.9C146.4,146,162,146,171.7,155.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.5804,
    y1: 446.9875,
    x2: 289.5804,
    y2: 236.1656,
    gradientTransform: "matrix(0.7071 0.7071 -1.0176 1.0176 794.8908 -658.2385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M544.8,1.4L544.8,1.4c-15.1-15.1-15.1-39.6,0-54.7l159.8-159.8c15.1-15.1,39.6-15.1,54.7,0l0,0 c15.1,15.1,15.1,39.6,0,54.7L599.5,1.4C584.4,16.5,559.9,16.5,544.8,1.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.4348,
    y1: 774.2708,
    x2: 371.4348,
    y2: 634.9731,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 944.6064 -807.9541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M659.8,2.2L659.8,2.2c-7.2-7.2-7.2-18.9,0-26.1l72.4-72.4c7.2-7.2,18.9-7.2,26.1,0l0,0 c7.2,7.2,7.2,18.9,0,26.1L685.8,2.2C678.6,9.4,667,9.4,659.8,2.2z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st76"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 410.3,
    cy: 122.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 23.8,
    cy: 58.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 646.1,
    y1: 119.5,
    x2: 646.1,
    y2: 126.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 649.4,
    y1: 122.8,
    x2: 642.7,
    y2: 122.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 176.6,
    y1: 59.2,
    x2: 176.6,
    y2: 65.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 179.9,
    y1: 62.5,
    x2: 173.2,
    y2: 62.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 516.7,
    y1: 199,
    x2: 516.7,
    y2: 205.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 520.1,
    y1: 202.4,
    x2: 513.4,
    y2: 202.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 496.6,
    y1: 199,
    x2: 496.6,
    y2: 205.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 499.9,
    y1: 202.4,
    x2: 493.3,
    y2: 202.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 476.5,
    y1: 199,
    x2: 476.5,
    y2: 205.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 479.8,
    y1: 202.4,
    x2: 473.2,
    y2: 202.4
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "255.7,40 260.8,31 250.5,31  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M247.6,175.8c2.3-2.3,6.2,1.7,8.5-0.6c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6 c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M444.3,157.3c2.3-2.3,6.2,1.7,8.5-0.6c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6 c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6c2.3-2.3-1.7-6.2,0.6-8.5c2.3-2.3,6.2,1.7,8.5-0.6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBg);
export default __webpack_public_path__ + "static/media/pdf_bg.bc4d255da376a4e6912c54fae018a73e.svg";
export { ForwardRef as ReactComponent };